import React from "react";
import { Headline, Paragraph } from "./ui";

const HeroSection = ({
  backgroundImage,
  headline,
  description,
  hasVignette = true,
  overlayOpacity = 0.4,
  renderDescription = false,
  className = "",
  style = {},
  ...props
}) => {
  return (
    <div
      className={`bg-cover bg-center bg-no-repeat relative ${className}`}
      style={{
        backgroundImage: `url('${backgroundImage}')`,
        backgroundColor: "var(--color-primary)", // Black fallback while image loads
        height: "100vh",
        zIndex: 0,
        marginTop: window.innerWidth <= 1000 ? "-80px" : "-120px",
        ...style,
      }}
      {...props}
    >
      {/* Base overlay */}
      <div
        className="absolute inset-0 bg-black"
        style={{ opacity: overlayOpacity }}
      ></div>

      {/* Vignette gradient - optional */}
      {hasVignette && (
        <div
          className="absolute bottom-0 left-0 right-0 h-2/3"
          style={{
            background:
              "linear-gradient(to top, var(--color-primary), rgba(10, 10, 10, 0.5), transparent)",
          }}
        ></div>
      )}

      {/* Content */}
      <div className="relative z-10 h-full flex items-end justify-center pb-0 sm:pb-4 max-w-7xl mx-auto">
        <div className="text-center">
          <Headline
            variant="huge"
            color="secondary"
            className="mb-0 text-left px-4 sm:p-4 mt-[-340px] sm:mt-[-240px]"
          >
            {headline}
          </Headline>
          {renderDescription && (
            <Paragraph
              variant="huge"
              color="secondary"
              className="max-w-none text-left p-4 hidden sm:block"
            >
              {description}
            </Paragraph>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
